import React from 'react';

export function DeviceColumn({ columnText }): JSX.Element {
  return <span>{columnText ? columnText : ''}</span>;
}
